import { immediateSendLog, sendLog } from '~/common/radar';
import { AIFeed } from '~/api/ai-feed';
import { AIActionType } from '../components/ai-actions-bar/scripts/ai_common';
import { commonPvParams, getQuery } from '~/common/utils';
import { AIFeedPageEnum } from '~/store/modules/ai-feed';

/* Debug Log */
export enum ChatLogErrorType {
    conversationIdNotFound = 'conversation_id_not_found',
    botIdNotFound = 'bot_id_not_found',
    networkError = 'network_error',
    serverError = 'server_error',
    modelError = 'model_error',
    other = 'other',
}

export enum ChatLogErrorInterface {
    getConversationId = 'getConversationId',
    createChat = 'chat',
    chatStreaming = 'chatStreaming',
}

export interface ChatLogErrorParams {
    type: ChatLogErrorType;
    reqUrl?: ChatLogErrorInterface;
    reqParam?: string;
    resResult?: string;
    errMsg?: string;
}

/* PV */
export const logForBotPageShow = (bot_index: number, user_id: string, country: string, botId: string) => {
    const params = commonPvParams({ defaultPageSource: 'aichat' });
    immediateSendLog({
        type: 'pv',
        name: 'AI_FRIENDS',
        value: {
            bot_id: botId || '',
            country,
            user_id,
            ...params,
            bot_index,
        },
    });
};

/* Click */
export const logForClickTopbarAction = (type: 'search' | 'history') => {
    sendLog({
        type: 'click',
        name: 'AI_CLICK_TOPBAR',
        value: {
            type,
        },
    });
};

// 引导对话点击消息
export const logForClickGuideChatAction = (feed: AIFeed, reply: string, reply_index: number) => {
    sendLog({
        type: 'click',
        name: 'GUIDE_DIALOG',
        value: {
            bot_id: feed.bot_id_str,
            reply_content: reply,
            reply_index,
        },
    });
};

// ai机器人点赞按钮
export const logForClickLikeButton = (feed: AIFeed, bot_index: Number, pageScene: AIFeedPageEnum | 'profile_pops') => {
    let scene = '';
    switch (pageScene) {
        case AIFeedPageEnum.AIForyou:
            scene = 'foryou';
            break;
        case AIFeedPageEnum.AIHistory:
            scene = 'history';
            break;
        case AIFeedPageEnum.AIChatRoom:
            scene = 'detail_page';
            break;
        case 'profile_pops':
            scene = 'profile_pops';
            break;
        default:
            break;
    }
    sendLog({
        type: 'click',
        name: 'AIFRIENDS_LIKE_BUTTON',
        value: {
            bot_id: feed.bot_id_str,
            bot_index,
            scene,
        },
    });
};

// ai机器人分享按钮
export const logForClickShareButton = (feed: AIFeed, bot_index: Number, pageScene: AIFeedPageEnum | 'profile_pops') => {
    let scene = '';
    switch (pageScene) {
        case AIFeedPageEnum.AIForyou:
            scene = 'foryou';
            break;
        case AIFeedPageEnum.AIHistory:
            scene = 'history';
            break;
        case AIFeedPageEnum.AIChatRoom:
            scene = 'detail_page';
            break;
        case 'profile_pops':
            scene = 'profile_pops';
            break;
        default:
            break;
    }
    sendLog({
        type: 'click',
        name: 'AIFRIENDS_SHARE_BUTTON',
        value: {
            bot_id: feed.bot_id_str,
            bot_index,
            scene,
        },
    });
};

// ai机器人举报按钮
export const logForClickReportButton = (feed: AIFeed, bot_index: Number, pageScene: AIFeedPageEnum | 'profile_pops') => {
    let scene = '';
    switch (pageScene) {
        case AIFeedPageEnum.AIForyou:
            scene = 'foryou';
            break;
        case AIFeedPageEnum.AIHistory:
            scene = 'history';
            break;
        case AIFeedPageEnum.AIChatRoom:
            scene = 'detail_page';
            break;
        case 'profile_pops':
            scene = 'profile_pops';
            break;
        default:
            break;
    }
    sendLog({
        type: 'click',
        name: 'AIFRIENDS_REPORT_BUTTON',
        value: {
            bot_id: feed.bot_id_str,
            bot_index,
            scene,
        },
    });
};

// Input Box
export const logForInputBox = (bot_id: string = '', input_type: 'voice' | 'text', click_area: 'chat_input' | 'type_to_vocie' | 'type_to_text') => {
    sendLog({
        type: 'click',
        name: 'CHAT_BOX_BUTTON',
        value: {
            bot_id,
            input_type,
            click_area,
        },
    });
};

export const logForInputBoxSwitchMode = (
    bot_id: string = '',
    input_type: 'text' | 'voice',
    click_area: 'chat_input' | 'type_to_vocie' | 'type_to_text'
) => {
    logForInputBox(bot_id, input_type, click_area);
};

export const logForInputBoxTextClick = (bot_id: string = '') => {
    logForInputBox(bot_id, 'text', 'chat_input');
};

export const logForInputBoxVoiceClick = (bot_id: string = '') => {
    logForInputBox(bot_id, 'voice', 'chat_input');
};

// 功能区
export const logForClickAction = (type: AIActionType, feed?: AIFeed) => {
    let typeStr = '';
    if (type === AIActionType.Like) {
        typeStr = 'like';
    } else if (type === AIActionType.UnLike) {
        typeStr = 'unlike';
    } else if (type === AIActionType.Share) {
        typeStr = 'share';
    } else {
        typeStr = 'view_history';
    }
    sendLog({
        type: 'click',
        name: 'INTERACT_BUTTON',
        value: {
            click_type: typeStr,
            bot_id: feed?.bot_id_str || '',
        },
    });
};

// bot信息弹窗内部点击
export const logForClickInfoPopupAction = (type: 'share' | 'report' | 'add_to_desktop', feed?: AIFeed) => {
    sendLog({
        type: 'click',
        name: 'CHARACTER_INFO_POPUP',
        value: {
            click_type: type,
            bot_id: feed?.bot_id_str || '',
        },
    });
};

// 安装pwa弹窗
export const logForClickInstallAction = (type: 'ok' | 'cancel', feed?: AIFeed) => {
    sendLog({
        type: 'click',
        name: 'ADD_TO_DESKTOP_POPUP',
        value: {
            type,
            bot_id: feed?.bot_id_str || '',
        },
    });
};

/* Show */
// bot信息弹窗展示
export const logForInfoShowAction = (feed?: AIFeed) => {
    sendLog({
        type: 'show',
        name: 'CHARACTER_INFO_POPUP',
        value: {
            bot_id: feed?.bot_id_str || '',
        },
    });
};

// bot展示埋点
export const logForBotShow = (bot_id: string, index: number, userId: string, country: string) => {
    logForBotPageShow(index + 1, userId, country, bot_id);
    console.log('ai-friends-logger', index + 1, userId, country, bot_id);
};

/* Task(show/click) */

// bot 发送、回复消息
export const logForChatWithBot = (
    botId?: string,
    conversationId?: string,
    index?: number,
    senderContent?: string,
    replierContent?: string,
    inputType?: 'text' | 'vioce',
    result?: 'none' | 'success' | 'failed',
    responseTime?: number,
    isMyself?: boolean,
    replyType?: 'auto_send' | undefined,
    failReason?: ChatLogErrorParams,
    totalConversation?: number
) => {
    const newIndex = index ? index + 1 : 1;
    const failReasonStr = failReason && JSON.stringify(failReason);
    sendLog({
        type: 'show',
        name: 'AI_BOT_CHAT',
        value: {
            conversation_id: conversationId || '',
            bot_id: botId || '',
            index: newIndex,
            send_content: senderContent || '',
            reply_content: replierContent || '',
            send_content_type: inputType,
            result,
            response_time: responseTime,
            is_myself: isMyself,
            reply_type: replyType,
            fail_reason: failReasonStr,
            total_conversation: totalConversation,
        },
    });
};

// bot发送事件
export const logForChatWithBotSend = (
    botId?: string,
    conversationId?: string,
    index?: number,
    senderContent?: string,
    inputType?: 'text' | 'vioce',
    isMyself?: boolean,
    reply_type?: 'auto_send' | undefined
) => {
    logForChatWithBot(botId, conversationId, index, senderContent, '', inputType, 'none', 0, isMyself, reply_type);
};

// bot回复事件
export const logForChatWithBotResponse = (
    botId?: string,
    conversationId?: string,
    index?: number,
    senderContent?: string,
    replierContent?: string,
    inputType?: 'text' | 'vioce',
    result?: 'success' | 'failed',
    responseTime?: number,
    isMyself?: boolean,
    replyType?: 'auto_send' | undefined,
    failReason?: ChatLogErrorParams,
    totalConversation?: number
) => {
    logForChatWithBot(
        botId,
        conversationId,
        index,
        senderContent,
        replierContent,
        inputType,
        result,
        responseTime,
        isMyself,
        replyType,
        failReason,
        totalConversation
    );
};

// bot回复task失败
export const logForChatWithBotFailed = (
    botId?: string,
    conversationId?: string,
    index?: number,
    sender?: string,
    replier?: string,
    inputType?: 'text' | 'vioce',
    responseTime?: number,
    failReason?: ChatLogErrorParams,
    totalConversation?: number
) => {
    logForChatWithBotResponse(
        botId,
        conversationId,
        index,
        sender,
        replier,
        inputType,
        'failed',
        responseTime,
        false,
        undefined,
        failReason,
        totalConversation
    );
};

// 顶部Top Tab
export const logForTopTabsSwitchShow = (tab_name: 'discovers' | 'ai_friends') => {
    sendLog({
        type: 'show',
        name: 'AIFRIEND_TAB',
        value: {
            tab_name,
        },
    });
};

export const logForTopTabsSwitchClick = (tab_name: 'discovers' | 'ai_friends' | 'messages' | 'history' | 'chat_list') => {
    sendLog({
        type: 'click',
        name: 'AIFRIEND_TAB',
        value: {
            tab_name,
        },
    });
};

// 顶部Top Bar
export const logForTopBarInboxBtnClick = (bot_id?: string, bot_index?: string) => {
    sendLog({
        type: 'click',
        name: 'MESSAGE_BUTTON',
        value: {
            bot_id,
            bot_index,
        },
    });
};

// 顶部Top Bar性别选择按钮
export const logForTopBarGenderSelectBtnClick = (bot_id?: string, bot_index?: string) => {
    sendLog({
        type: 'click',
        name: 'GENDER_SELECT_BUTTON',
        value: {
            bot_id,
            bot_index,
        },
    });
};

// 顶部Top Bar UGC入口
export const logForTopBarUGCEntranceBtnClick = (bot_id?: string, bot_index?: string) => {
    sendLog({
        type: 'click',
        name: 'ADD_NEWBOT_BUTTON',
        value: {
            bot_id,
            bot_index,
        },
    });
};

// 声音播放按钮点击
export const logForPlaySoundBtnClick = (
    bot_id?: string,
    button_type?: 'play' | 'stop',
    bot_index?: number,
    message_index?: number,
    conversation_id?: string
) => {
    sendLog({
        type: 'click',
        name: 'PLAY_SOUND_BUTTON',
        value: {
            bot_id,
            button_type,
            index: bot_index,
            message_index,
            conversation_id,
        },
    });
};

// 声音播放按钮曝光
export const logForPlaySoundBtnShow = (bot_id?: string, bot_index?: number, message_index?: number, conversation_id?: string) => {
    sendLog({
        type: 'show',
        name: 'PLAY_SOUND_BUTTON',
        value: {
            bot_id,
            index: bot_index,
            message_index,
            conversation_id,
        },
    });
};

// 音色创建点击事件
export const logForVoiceCreateStatusClick = (create_status: boolean) => {
    sendLog({
        type: 'click',
        name: 'VOICE_CREATE_STATUS',
        value: {
            create_status,
        },
    });
};

// Fantasay引流弹窗曝光事件
export const logForFantasyPopupShow = (source: 'voice' | 'dialogue') => {
    sendLog({
        type: 'show',
        name: 'FANTASAY_GUIDE_POPUP',
        value: {
            source,
        },
    });
};

// Fantasay引流弹窗点击事件
export const logForFantasyPopupClick = (source: 'voice' | 'dialogue', click_area: 'close' | 'go') => {
    sendLog({
        type: 'click',
        name: 'FANTASAY_GUIDE_POPUP',
        value: {
            source,
            click_area,
        },
    });
};

// 客服页反馈提交成功弹窗曝光事件
export const logForCustomerServiceFeedbackPopupShow = () => {
    sendLog({
        type: 'show',
        name: 'SUBMIT_SUCCESS_POPUP',
    });
};

// 客服页反馈提交成功弹窗点击事件
export const logForCustomerServiceFeedbackPopupClick = (click_area: 'close' | 'open') => {
    sendLog({
        type: 'click',
        name: 'SUBMIT_SUCCESS_POPUP',
        value: {
            click_area,
        },
    });
};
